// extracted by mini-css-extract-plugin
module.exports = {"c1fhi0na":"c1fhi0na"};